import { SvgBase } from "../svg.base";

export const Search = () => (
  <SvgBase>
    <path
      fill="currentColor"
      d="M18.5 17h-.79l-.28-.27A6.471 6.471 0 0 0 19 12.5a6.5 6.5 0 1 0-6.5 6.5c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L23.49 22l-4.99-5zm-6 0C10.01 17 8 14.99 8 12.5S10.01 8 12.5 8s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z"
    />
  </SvgBase>
);